import type { AnchorHTMLAttributes, MouseEvent } from "react";
import { navigate, type RoutePath } from "./router.js";
import { usePath } from "./useRoute.js";

export interface LinkProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> {
  to: RoutePath;
}

/**
 * In-app link. It stays a real anchor (middle click, copy address) and only
 * intercepts a plain left click to navigate without a reload.
 */
export function Link({ to, onClick, ...rest }: LinkProps) {
  const active = usePath() === to;

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);
    if (event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    navigate(to);
  };

  return (
    <a href={to} onClick={handleClick} {...(active ? { "aria-current": "page" as const } : {})} {...rest} />
  );
}
